import React, { useState, useEffect } from "react";
import apiClient from "../../axios";
import LoginNotification from "../Notifications/LoginNotification";
import ErrorNotification from '../Notifications/ErrorNotification';
import Loader from "../Loader";
import Table from '../../components/Table';
import { faRectangleList } from '@fortawesome/free-solid-svg-icons';
import './ViewProductTypes.css';

const ViewProductTypes = ({ isVisible, onClose, item, itemDesc }) => {
    const [isInfoVisible, setIsInfoVisible] = useState(false);
    const [isErrorVisible, setIsErrorVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [totalItems, setTotalItems] = useState(0);
    const itemsPerPage = 10;
    //const [productType, setProductType] = useState([]);
    const [data, setData] = useState([]);
    //const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
        const fetchAllData = async () => {
            try {
                setLoading(true);
                console.log(item);
                const response = await apiClient.get(`/contract_type/${item}`);
                if (Array.isArray(response.data.productTypes)) {
                    setData(response.data.productTypes);
                    setTotalItems(1);
                } else {
                    setData([response.data]);
                    setTotalItems(1);
                }
            } catch (error) {
                console.error("Error fetching assigned product types:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchAllData();
    }, [item]);

    const columns = [
        { title: "Id", key: "id" },
        { title: "Código", key: "code" },
        { title: "Descripción", key: "description" },
    ];

    const renderRow = (item, index) => (
        <>
            <td>{item.id}</td>
            <td>{item.code}</td>
            <td>{item.description}</td>
        </>
    );

    return (
        isVisible && (
            <div className="info-notification-info-overlay">
                <div className="info-notification-info2">
                    <div className="message-container-info">
                        <h3 className="basic-info-form-title">{`Tipos de Producto correspondientes al Tipo de Contrato (${itemDesc})`}</h3>
                    </div>
                    <div className="message-container-info">
                        <div className="basic-info-form-group-add">
                            <div className="product-types-list">
                                {data.length > 0 ? (
                                    <Table 
                                        title="Lista de Tipos de Producto"
                                        rows={data}
                                        columns={columns}
                                        icon={faRectangleList}
                                        renderRow={renderRow}
                                        totalItems={totalItems}
                                        itemsPerPage={itemsPerPage}
                                        loading={loading}
                                    />
                                ) : (
                                    <p>No hay tipos de producto asignados</p>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="button-container-info">
                        <button className="ok-btn-info" onClick={onClose}>
                            Cerrar
                        </button>
                    </div>
                    {loading && <Loader />}
                    <ErrorNotification
                        message="Ups! Ocurrió un Problema"
                        isVisible={isErrorVisible}
                        onClose={() => setIsErrorVisible(false)}
                    />
                    <LoginNotification
                        message="Vuelve a iniciar sesión"
                        isVisible={isInfoVisible}
                        onClose={() => setIsInfoVisible(false)}
                    />
                </div>
            </div>
        )
    );
};

export default ViewProductTypes;
